import { k } from "../kaplay";

import { properties } from "../data/properties";
import { addFireball } from "../gameobjects/fireball";

export function fireballs(){
  return {
    id: "fireballs",
    spawning_fireballs: false,
    // canCast: true,
    setFireballNumber(number){
      properties.fireball.number = number;
    },
    async createFireballs(angle){
      if (!this.canCast) return;

      for(let i = 0; i < properties.fireball.number; i++){
        addFireball({ angle: angle });
        await k.wait(0.2);
      }
    },
    update() {
      if (!this.spawning_fireballs && this.canCast){
        this.spawning_fireballs = true;

        k.wait(properties.fireball.spawnSpeed, () => {
          this.spawning_fireballs = false;

          let closestEnemy = null;
          let closestDist = 999999999;
          k.get("enemy").forEach((enemy) => {
            if (!closestEnemy){
              closestEnemy = enemy;
              closestDist = k.Vec2.dist(enemy.pos, k.center());
              return;
            }

            const enemyDist = k.Vec2.dist(enemy.pos, k.center());
            if (enemyDist < closestDist){
              closestDist = enemyDist;
              closestEnemy = enemy;
            }
          })

          if (closestEnemy){
            const dx = (closestEnemy.pos.x) - k.center().x;
            const dy = (closestEnemy.pos.y) - k.center().y;
            let angle = Math.atan2(dy, dx) * 180 / Math.PI;
            this.createFireballs(angle);
          }
        })
      }
    },
    destroy(){
      k.get("fireball").forEach((s) => s.destroy());
    }
  }
}